/**
 * Crea la bolilla que indica el número ganador
 * @param {*} scene
 */
export function crearBolilla(scene) {
  scene.bolillaFondo = scene.add.image(866, 52, "bolillaFondoVerde");
  scene.bolillaValor = scene.add.image(866, 34, "ultimoNumero0");

  // Números en movimiento
  scene.anims.create({
    key: "numerosMovimiento",
    frames: scene.anims.generateFrameNumbers("numerosBolillaMovimiento", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.numerosMovimiento = scene.add
    .sprite(866, 52, "numerosMovimiento")
    .setVisible(false);

  // Bolilla fondo verde en movimiento
  scene.anims.create({
    key: "fondoVerdeMovimiento",
    frames: scene.anims.generateFrameNumbers("bolillaFondoVerdeMovimiento", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.fondoVerdeMovimiento = scene.add
    .sprite(866, 52, "fondoVerdeMovimiento")
    .setVisible(false);

  // Bolilla fondo negro en movimiento
  scene.anims.create({
    key: "fondoNegroMovimiento",
    frames: scene.anims.generateFrameNumbers("bolillaFondoNegroMovimiento", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.fondoNegroMovimiento = scene.add
    .sprite(866, 52, "fondoNegroMovimiento")
    .setVisible(false);

  // Bolilla fondo rojo en movimiento
  scene.anims.create({
    key: "fondoRojoMovimiento",
    frames: scene.anims.generateFrameNumbers("bolillaFondoRojoMovimiento", {
      start: 0,
      end: 11,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.fondoRojoMovimiento = scene.add
    .sprite(866, 52, "fondoRojoMovimiento")
    .setVisible(false);
}
